var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

module.exports = function (e) {
  var t = {};

  function o(n) {
    if (t[n]) return t[n].exports;
    var r = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(r.exports, r, r.exports, o), r.l = !0, r.exports;
  }

  return o.m = e, o.c = t, o.d = function (e, t, n) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (e, t) {
    if (1 & t && (e = o(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) {
      o.d(n, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return n;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 1);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, o) {
  "use strict";

  o.r(t), o.d(t, "default", function () {
    return u;
  }), o.d(t, "useIdentityContext", function () {
    return l;
  });
  var n = o(0),
      r = o.n(n);
  var a = /(confirmation|invite|recovery|email_change|access)_token=([^&]+)/,
      i = /^#\/?/;

  var s = function s(_ref) {
    var e = _ref.url;

    var _Object = Object(n.useState)(),
        _Object2 = _slicedToArray(_Object, 2),
        t = _Object2[0],
        o = _Object2[1],
        _Object3 = Object(n.useState)(),
        _Object4 = _slicedToArray(_Object3, 2),
        r = _Object4[0],
        s = _Object4[1],
        _Object5 = Object(n.useState)(),
        _Object6 = _slicedToArray(_Object5, 2),
        c = _Object6[0],
        l = _Object6[1],
        _Object7 = Object(n.useState)(),
        _Object8 = _slicedToArray(_Object7, 2),
        u = _Object8[0],
        d = _Object8[1],
        _Object9 = Object(n.useState)(),
        _Object10 = _slicedToArray(_Object9, 2),
        f = _Object10[0],
        p = _Object10[1],
        _Object11 = Object(n.useState)(),
        _Object12 = _slicedToArray(_Object11, 2),
        m = _Object12[0],
        g = _Object12[1],
        _Object13 = Object(n.useState)(),
        _Object14 = _slicedToArray(_Object13, 2),
        y = _Object14[0],
        h = _Object14[1],
        b = Object(n.useMemo)(function () {
      return e + "/.netlify/identity";
    }, [e]),
        O = Object(n.useCallback)( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (r) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Cannot authorizedFetch while logged out");

              case 2:
                return _context.abrupt("return", fetch(e, _objectSpread(_objectSpread({}, t), {}, {
                  headers: _objectSpread(_objectSpread({}, null == t ? void 0 : t.headers), {}, {
                    Authorization: "Bearer " + r.access_token
                  })
                })));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }(), [r]),
        w = Object(n.useCallback)(function (e) {
      var t = new Date(1e3 * JSON.parse(window.atob(e.access_token.split(".")[1])).exp);
      s(_objectSpread(_objectSpread({}, e), {}, {
        expires_at: t
      }));
    }, []),
        v = Object(n.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = w;
              _context2.next = 3;
              return fetch(b + "/token", {
                method: "POST",
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                },
                body: "grant_type=refresh_token&refresh_token=" + r.refresh_token
              }).then(function (e) {
                return e.json();
              });

            case 3:
              _context2.t1 = _context2.sent;
              (0, _context2.t0)(_context2.t1);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })), [w, b, r]),
        j = Object(n.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log("Logging Out"), localStorage.removeItem("ni.goTrueToken"), localStorage.removeItem("ni.user"), s(), o(), m && (clearTimeout(m), g());

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })), [m]);

    Object(n.useEffect)(function () {
      if (r) {
        localStorage.setItem("ni.goTrueToken", JSON.stringify(r));

        var _e = Math.max(new Date(r.expires_at).getTime() - new Date().getTime() - 24e4, 0);

        console.log("Refresh goTrueToken in ".concat((_e / 1e3).toFixed(0), " seconds")), g(setTimeout(v, _e));
      }
    }, [r, v]), Object(n.useEffect)(function () {
      t && localStorage.setItem("ni.user", JSON.stringify(t));
    }, [t]), Object(n.useEffect)(function () {
      var e = localStorage.getItem("ni.goTrueToken"),
          t = localStorage.getItem("ni.user");
      e && t && (s(JSON.parse(e)), o(JSON.parse(t)), p());
    }, []), Object(n.useEffect)(function () {
      l(function () {
        var e, t;
        if (null === (e = document) || void 0 === e || null === (t = e.location) || void 0 === t || !t.hash) return null;
        var o = document.location.hash.replace(i, "");

        try {
          window && window.history.pushState("", document.title, window.location.pathname + window.location.search);
        } catch (e) {
          window.location.href.substr(0, window.location.href.indexOf("#"));
        }

        var n = o.match(a);
        return n ? {
          type: n[1],
          token: n[2]
        } : null;
      }());
    }, []), Object(n.useEffect)(function () {
      "confirmation" !== (null == c ? void 0 : c.type) && "recovery" !== (null == c ? void 0 : c.type) && "invite" !== (null == c ? void 0 : c.type) || !r ? "confirmation" === (null == c ? void 0 : c.type) ? (console.log("Confirming User"), fetch(b + "/verify", {
        method: "POST",
        body: JSON.stringify({
          token: c.token,
          type: "signup"
        })
      }).then(function (e) {
        return e.json();
      }).then(function (e) {
        404 === e.code ? (console.log("Confirmation token attempted that's already been consumed; logging out"), l()) : (l(), w(e));
      })) : "recovery" === (null == c ? void 0 : c.type) && (console.log("Recovering User"), fetch(b + "/verify", {
        method: "POST",
        body: JSON.stringify({
          token: c.token,
          type: "recovery"
        })
      }).then(function (e) {
        return e.json();
      }).then(function (e) {
        404 === e.code ? (console.log("Recovery token attempted that's already been consumed; logging out"), l()) : (l({
          type: "passwordRecovery"
        }), w(e));
      })) : j();
    }, [b, w, l, r, j, c]);

    var S = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5) {
        var e, t, o;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                e = _ref5.email, t = _ref5.password;
                _context4.next = 3;
                return fetch(b + "/token", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                  },
                  body: "grant_type=password&username=".concat(encodeURIComponent(e), "&password=").concat(encodeURIComponent(t))
                }).then(function (e) {
                  return e.json();
                });

              case 3:
                o = _context4.sent;

                if (!(null != o && o.error_description)) {
                  _context4.next = 6;
                  break;
                }

                throw new Error(o.error_description);

              case 6:
                w(o);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function S(_x3) {
        return _ref6.apply(this, arguments);
      };
    }(),
        k = Object(n.useCallback)( /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
        var t;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                delete Object.assign(e, {
                  data: e.user_metadata
                }).user_metadata;
                _context5.next = 3;
                return O(b + "/user", {
                  method: "PUT",
                  body: JSON.stringify(e)
                }).then(function (e) {
                  return e.json();
                });

              case 3:
                t = _context5.sent;
                o(t), h(!0);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x4) {
        return _ref7.apply(this, arguments);
      };
    }(), [b, O, o, h]);

    Object(n.useEffect)(function () {
      r && t && u && (d(), k(u));
    }, [r, t, u, k]), Object(n.useEffect)(function () {
      c && "email_change" === c.type && t && (console.log("Confirming Email Change"), d({
        email_change_token: c.token
      }), l());
    }, [c, t, k]), Object(n.useEffect)(function () {
      r && !t && O(b + "/user").then(function (e) {
        return e.json();
      }).then(function (e) {
        return o(e);
      });
    }, [b, o, O, r, t]);
    Object(n.useEffect)(function () {
      r && y && (clearTimeout(m), v(), h());
    }, [r, y, v, m]);
    var T = Object(n.useMemo)(function () {
      return (null == t ? void 0 : t.email) !== (null == t ? void 0 : t.new_email) && (null == t ? void 0 : t.new_email);
    }, [t]);
    return {
      user: t,
      login: S,
      logout: j,
      update: k,
      signup: function () {
        var _signup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  delete Object.assign(e, {
                    data: e.user_metadata
                  }).user_metadata;
                  _context6.next = 3;
                  return fetch(b + "/signup", {
                    method: "POST",
                    body: JSON.stringify(e)
                  }).then(function (e) {
                    return e.json();
                  });

                case 3:
                  t = _context6.sent;

                  if (!(null != t && t.msg)) {
                    _context6.next = 6;
                    break;
                  }

                  throw new Error(t.msg);

                case 6:
                  if (!(null != t && t.confirmed_at)) {
                    _context6.next = 11;
                    break;
                  }

                  _context6.next = 9;
                  return S(e);

                case 9:
                  _context6.next = 12;
                  break;

                case 11:
                  p(t);

                case 12:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        function signup(_x5) {
          return _signup.apply(this, arguments);
        }

        return signup;
      }(),
      urlToken: c,
      refreshUser: k,
      authorizedFetch: O,
      provisionalUser: f,
      pendingEmailUpdate: T,
      sendPasswordRecovery: function () {
        var _sendPasswordRecovery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref8) {
          var e;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  e = _ref8.email;
                  return _context7.abrupt("return", fetch(b + "/recover", {
                    method: "POST",
                    body: JSON.stringify({
                      email: e
                    })
                  }));

                case 2:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        function sendPasswordRecovery(_x6) {
          return _sendPasswordRecovery.apply(this, arguments);
        }

        return sendPasswordRecovery;
      }(),
      completeUrlTokenTwoStep: function () {
        var _completeUrlTokenTwoStep = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref9) {
          var e, t, _o;

          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  e = _ref9.password, t = _objectWithoutProperties(_ref9, ["password"]);

                  if (!("passwordRecovery" === (null == c ? void 0 : c.type))) {
                    _context8.next = 5;
                    break;
                  }

                  console.log("Updating Password & Clearing URL Token"), d({
                    password: e
                  }), l();
                  _context8.next = 11;
                  break;

                case 5:
                  if (!("invite" === (null == c ? void 0 : c.type))) {
                    _context8.next = 11;
                    break;
                  }

                  console.log("Setting Up Invited User");
                  _context8.next = 9;
                  return fetch(b + "/verify", {
                    method: "POST",
                    body: JSON.stringify({
                      token: c.token,
                      type: "signup",
                      password: e
                    })
                  }).then(function (e) {
                    return e.json();
                  });

                case 9:
                  _o = _context8.sent;
                  l(), w(_o), d(t);

                case 11:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        function completeUrlTokenTwoStep(_x7) {
          return _completeUrlTokenTwoStep.apply(this, arguments);
        }

        return completeUrlTokenTwoStep;
      }()
    };
  },
      c = Object(n.createContext)(),
      l = function l() {
    return Object(n.useContext)(c);
  },
      u = function u(_ref10) {
    var e = _ref10.url,
        t = _ref10.children;
    if (!e) throw new Error("No Identity URL defined! Use format https://example.com - no trailing slash");
    var o = s({
      url: e
    });
    return r.a.createElement(c.Provider, {
      value: o
    }, t);
  };
}]);